const Facilities = () => {
  const facilities = [
    {
      name: 'Headquarters & Main Factory',
      location: '716-41 Nishikumado, Numazu City, Shizuoka Prefecture',
      description: 'Our main manufacturing facility equipped with state-of-the-art gun drilling machines and precision equipment.',
      image: 'https://www.hi-tak.co.jp/wp-content/uploads/2022/12/image.png',
      features: ['Gun Drilling Machines', 'Honing Equipment', 'Quality Control Lab', 'R&D Center']
    }
  ];

  return (
    <section className="py-24 bg-white">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
        <div className="text-center mb-16">
          <span className="text-[#00D9C9] text-sm font-semibold tracking-wider uppercase">Our Facilities</span>
          <h2 className="text-4xl lg:text-5xl font-bold text-[#001E3C] mt-4 mb-6">
            Global Manufacturing Excellence
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Advanced facilities delivering precision manufacturing solutions
          </p>
        </div>

        <div className="space-y-8">
          {facilities.map((facility, index) => (
            <div key={index} className="bg-gradient-to-br from-gray-50 to-white rounded-2xl overflow-hidden border border-gray-200 hover:border-[#00D9C9] transition-all duration-300 shadow-lg hover:shadow-xl">
              <div className="grid lg:grid-cols-2 gap-0">
                <div className="relative h-[400px] lg:h-auto">
                  <img
                    src={facility.image}
                    alt={facility.name}
                    className="w-full h-full object-cover object-top"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent"></div>
                </div>
                
                <div className="p-8 lg:p-12 flex flex-col justify-center">
                  <h3 className="text-3xl font-bold text-[#001E3C] mb-4">
                    {facility.name}
                  </h3>
                  
                  <div className="flex items-start gap-3 mb-6">
                    <i className="ri-map-pin-line text-[#00D9C9] text-xl mt-1 w-6 h-6 flex items-center justify-center"></i>
                    <p className="text-gray-600">{facility.location}</p>
                  </div>
                  
                  <p className="text-gray-700 mb-8 leading-relaxed">
                    {facility.description}
                  </p>

                  <div className="grid grid-cols-2 gap-4">
                    {facility.features.map((feature, idx) => (
                      <div key={idx} className="flex items-center gap-2">
                        <div className="w-2 h-2 bg-[#00D9C9] rounded-full"></div>
                        <span className="text-sm text-gray-700">{feature}</span>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Facilities;
